import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
import { MessageType } from 'src/reference-data/message-type.enum';
export const MessageReducer = (state = { key: '', type: MessageType.SUCCESS }, { type, payload }) => {
    switch (type) {
        case MultichainActionType.SET_MESSAGE:
            return payload;
        default:
            return state;
    }
};
